export default __webpack_public_path__ + "static/media/Gaurikund.41f92227.jpg";